import { type Place } from '../types/place-types';

// eslint-disable-next-line import/prefer-default-export
export const MIN_SEARCH_RADIUS_M = 6437.376;

export const PLACE_ANYWHERE: Place = {
  bbox: {
    latitudeNorthEast: 80.4527499048857,
    latitudeSouthWest: -68.95724912823127,
    longitudeNorthEast: 128.8178367614746,
    longitudeSouthWest: -139.0727882385254,
  },
  fullName: 'Anywhere',
  geometry: {
    coordinates: {
      latitude: 0,
      longitude: 0,
    },
  },
  id: 'anywhere',
};
